import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { history } from '#redux/store';
import api, { apiSetup } from '#config/api';
import { useLogout } from '#hooks/useLogout';
import AuthActions from '#redux/Auth/actions';

import Routes from './components/ConnectedRoutes';

const AppRoutesContainer = () => {
  const dispatch = useDispatch();
  const logout = useLogout();
  useEffect(() => {
    dispatch(AuthActions.init());
    apiSetup(api, logout);
  }, [dispatch]);
  return (
    <ConnectedRouter history={history}>
      <Routes />
    </ConnectedRouter>
  );
};

export default AppRoutesContainer;
